
 

 

 

 
class IssueData 
{
    
        Id: string | null;
    
        Title: string;
    
        Description: string;
    
        RequestorName: string;
    
        RequestorEmail: string;
    
        RequestorPhone: string;
    
        ApproveByUser: string;
    
        ApproveDate: Date | null;
    
        IssueDate: Date;
    
        Status: any;
    
        IssueType: any;
    
        FileInfoList: any;
    
}
 
export default IssueData;
 




